module.exports = __webpack_public_path__ + "media/images/proof_links/colored/shopify-5d9d60bdce81339b2dac3d3a08615290.svg";